'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var ToggleButtonGroup$1 = require('../../../node_modules/@material-ui/lab/esm/ToggleButtonGroup/ToggleButtonGroup.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"]({
  grouped: function grouped(_ref) {
    var equalWidth = _ref.equalWidth,
        fullWidth = _ref.fullWidth;
    if (equalWidth) return {
      flex: '1 1 0px',
      minWidth: 0
    };
    if (fullWidth) return {
      flex: '1 1 auto'
    };
  },
  root: function root(_ref2) {
    var fullWidth = _ref2.fullWidth;
    return fullWidth && {
      width: '100%'
    };
  }
});
var ToggleButtonGroup = React.forwardRef(function (_ref3, ref) {
  var equalWidth = _ref3.equalWidth,
      fullWidth = _ref3.fullWidth,
      classes = _ref3.classes,
      restProps = objectWithoutProperties(_ref3, ["equalWidth", "fullWidth", "classes"]);

  var _useStyles = useStyles({
    equalWidth: equalWidth,
    fullWidth: fullWidth
  }),
      grouped = _useStyles.grouped,
      root = _useStyles.root;

  var appliedClasses = _objectSpread({
    grouped: grouped,
    root: root
  }, classes);

  return React__default["default"].createElement(ToggleButtonGroup$1["default"], _objectSpread({
    classes: appliedClasses,
    ref: ref
  }, restProps));
});

module.exports = ToggleButtonGroup;
